import React from "react";
import Static from "../../components/global/Statics/Static";
import Layout from "../../components/layout/Layout/Layout";
import Header from "../../components/layout/Header/Header";

export default function StaticsPage() {
  return (
    <Layout>
      <Header></Header>
      <Static />
    </Layout>
  );
}
